import { PurchasesByProductModel } from "@iewc/Types/CustomApiModels";
import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export interface CustomSpendReportingStateType {
    readonly isLoading: boolean;
    readonly yearSelected: number;
    readonly data: PurchasesByProductModel;
}

export type CustomPurchasesByProductState = Readonly<CustomSpendReportingStateType>;

export const initalPurchasesByProductState: CustomPurchasesByProductState = {
    isLoading: true,
    yearSelected: new Date().getFullYear(),
    data: {
        uri: "",
        customerNumber: "",
        year: 0,
        availableYears: [],
        productGroups: [],
        properties: {},
    },
};

export const customPurchasesByProductReducer = createTypedReducer(initalPurchasesByProductState, {
    "Custom/PurchasesByProductState/SetIsLoading": (
        draft: Draft<CustomPurchasesByProductState>,
        { isLoading }: { isLoading: boolean },
    ) => ({
        ...draft,
        isLoading,
    }),
    "Custom/PurchasesByProductState/SetYearSelected": (
        draft: Draft<CustomPurchasesByProductState>,
        { yearSelected }: { yearSelected: number },
    ) => ({
        ...draft,
        yearSelected,
    }),
    "Custom/PurchasesByProductState/SetData": (
        draft: Draft<CustomPurchasesByProductState>,
        { data }: { data: PurchasesByProductModel },
    ) => ({
        ...draft,
        data,
    }),
});
